import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeposit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.3333)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Huge-icon/ecommerce/outline/deposit",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M4.5 9.75L4.5 12.75L13.5 12.75L13.5 3.75C13.5 2.92157 12.8284 2.25 12 2.25L6 2.25C5.17157 2.25 4.5 2.92157 4.5 3.75L4.5 9.75ZM4.5 9.75C2.84315 9.75 1.5 11.0931 1.5 12.75C1.5 14.4069 2.84315 15.75 4.5 15.75L13.5 15.75C15.1569 15.75 16.5 14.4069 16.5 12.75C16.5 11.0931 15.1569 9.75 13.5 9.75",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M7.5 8.56066L8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033L10.5 8.56066M9 5.56066L9 9.31066",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			})]
		})
	})]
});
const ForwardRef = forwardRef(SvgDeposit);
export default ForwardRef;
